export default "__VITE_ASSET__DhJFrYhN__"